import type { ComponentProps } from "react";
import { cn } from "~/shared/lib";

type ButtonProps = ComponentProps<"button">;

export function Button({ children, className, ...props }: ButtonProps) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        "flex cursor-pointer items-center gap-2 px-4 py-2 text-xs transition-colors duration-300 disabled:cursor-not-allowed sm:text-sm lg:text-base",
        className,
      )}
    >
      {children}
    </button>
  );
}
